var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFailure(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 260,
    height: 260,
    viewBox: "0 0 260 260",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.f{fill:#fff;}.a{stroke:#707070;}.b{clip-path:url(#a);}.c,.e{fill:#dd4b64;}.c{opacity:0.198;}.d{fill:#1f0256;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 260,
    height: 260,
    transform: "translate(538 247)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(-538 -247)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.961 15.961)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 100,
    cy: 100,
    r: 100,
    transform: "translate(552.039 261.039)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(586.496 306.708)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M2741.571,868.552l26.465,15.878-.092,30.767-26.373-15.308Z",
    transform: "translate(-2741.571 -805.987)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2772.152,913.969l39.176-22.618V859.629L2772.244,883.2Z",
    transform: "translate(-2745.779 -804.759)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2889.479,868.471l-26.58,15.948.091,30.767,26.488-15.378Z",
    transform: "translate(-2758.265 -805.976)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M2856.755,913.969l-39.176-22.618V859.629l39.085,23.573Z",
    transform: "translate(-2752.029 -804.759)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M2741.571,858.57l26.465,15.878,39.085-23.573,39.085,23.573,26.58-15.948-39.347-23.844,38.963-22.844-26.1-15.534-39.092,22.584L2768.525,796l-26.394,15.762,38.963,22.857Z",
    transform: "translate(-2741.571 -796.005)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2887.058,845.167V814.334l-38.963,22.844L2874.21,853Z",
    transform: "translate(-2756.228 -798.527)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M2742.22,845.115V814.282l38.963,22.844-26.115,15.825Z",
    transform: "translate(-2741.66 -798.52)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailure);
export default __webpack_public_path__ + "static/media/failure.01c3984d6e24a147993ef5c11a7e045d.svg";
export { ForwardRef as ReactComponent };